// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9dfMe","importantInfo":"styles_importantInfo__37VEv"};